export default "__VITE_ASSET__DIp7m_t5__"